import OpeningHoursView from './OpeningHoursView';
import OnlineOrdering from './online-ordering';
import Reservations from './reservations';
import Storefront from './storefront';

export default {
  OpeningHoursView,
  OnlineOrdering,
  Reservations,
  Storefront,
};
